import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  JOB_AIAS_REFRESH: createSagaAction('JOB_AIAS_REFRESH'),

  JOB_AIA_CREATE: createSagaAction('JOB_AIA_CREATE'),
  JOB_AIA_UPDATE: createSagaAction('JOB_AIA_UPDATE'),
  JOB_AIA_DELETE: createSagaAction('JOB_AIA_DELETE'),

  UPLOAD_AIA_ATTACHMENT: createSagaAction('UPLOAD_AIA_ATTACHMENT'),
  GET_AIA_ATTACHMENTS: createSagaAction('GET_AIA_ATTACHMENTS'),
  UPDATE_AIA_ATTACHMENT_DESCRIPTION: createSagaAction('UPDATE_AIA_ATTACHMENT_DESCRIPTION'),
  DELETE_AIA_ATTACHMENT: createSagaAction('DELETE_AIA_ATTACHMENT'),

  GET_AIA_ACTIVITIES: createSagaAction('GET_AIA_ACTIVITIES'),

  // notes
  GET_AIA_NOTE: createSagaAction('GET_AIA_NOTE'),
  CREATE_AIA_NOTE: createSagaAction('CREATE_AIA_NOTE'),
  EDIT_AIA_NOTE: createSagaAction('EDIT_AIA_NOTE'),
  DELETE_AIA_NOTE: createSagaAction('DELETE_AIA_NOTE')
}

// Action Creators
export const actions = {
  jobAiasRefresh: ({ jobId, assignedToId, fromDashboard, next }) => ({
    type: constants.JOB_AIAS_REFRESH.ACTION,
    jobId,
    assignedToId,
    fromDashboard,
    next
  }),

  createJobAia: ({ formData, jobId }) => ({
    type: constants.JOB_AIA_CREATE.ACTION,
    formData,
    jobId
  }),

  updateJobAia: ({ jobId, aiaId, userId, content }) => ({
    type: constants.JOB_AIA_UPDATE.ACTION,
    jobId,
    aiaId,
    userId,
    content
  }),

  deleteJobAia: ({ aiaId, jobId }) => ({
    type: constants.JOB_AIA_DELETE.ACTION,
    jobId,
    aiaId
  }),

  // Attachment actions
  uploadAttachment: ({ formData, aiaId }) => ({
    type: constants.UPLOAD_AIA_ATTACHMENT.ACTION,
    formData,
    aiaId
  }),

  getAiaAttachments: ({ aiaId }) => ({
    type: constants.GET_AIA_ATTACHMENTS.ACTION,
    aiaId
  }),

  updateAttachmentDescription: ({ attachmentId, aiaId, description, userId }) => ({
    type: constants.UPDATE_AIA_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    aiaId,
    description,
    userId
  }),

  deleteAttachment: ({ attachmentId, aiaId }) => ({
    type: constants.DELETE_AIA_ATTACHMENT.ACTION,
    attachmentId,
    aiaId
  }),

  getAiaActivities: ({ aiaId }) => ({
    type: constants.GET_AIA_ACTIVITIES.ACTION,
    aiaId
  }),
  // notes
  getAiaNote: ({ aiaId }) => ({
    type: constants.GET_AIA_NOTE.ACTION,
    aiaId
  }),
  createAiaNote: ({ content, userId, aiaId }) => ({
    type: constants.CREATE_AIA_NOTE.ACTION,
    content,
    userId,
    aiaId
  }),
  editAiaNote: ({ content, noteId, aiaId }) => ({
    type: constants.EDIT_AIA_NOTE.ACTION,
    content,
    noteId,
    aiaId
  }),
  deleteAiaNote: ({ noteId, aiaId }) => ({
    type: constants.DELETE_AIA_NOTE.ACTION,
    noteId,
    aiaId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.JOB_AIAS_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.JOB_AIAS_REFRESH.SUCCESS:
      return {
        ...state,
        jobAias: action.payload
      }
    case constants.JOB_AIAS_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.JOB_AIA_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_AIA_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_AIA_DELETE.SUCCESS:
      return {
        ...state
      }

    case constants.UPLOAD_AIA_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingAttachment: true }
    case constants.UPLOAD_AIA_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingAttachment: false
      }

    case constants.GET_AIA_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingAttachments: true }
    case constants.GET_AIA_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        jobAiaAttachments: action.payload,
        loadingAttachments: false
      }

    case constants.UPDATE_AIA_ATTACHMENT_DESCRIPTION.SUCCESS:
      return {
        ...state
      }

    case constants.DELETE_AIA_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingAttachment: true }
    case constants.DELETE_AIA_ATTACHMENT.SUCCESS:
      return {
        ...state,
        deletingAttachment: false
      }
    case constants.GET_AIA_ACTIVITIES.SUCCESS:
      return {
        ...state,
        aiaActivities: action.payload
      }
    // NOTES
    case constants.GET_AIA_NOTE.SUCCESS:
      return { ...state, aiaNotes: action.payload }

    case constants.CREATE_AIA_NOTE.ACTION:
      return { ...state }
    case constants.CREATE_AIA_NOTE.SUCCESS:
      return {
        ...state
      }
    case constants.EDIT_AIA_NOTE.ACTION:
      return { ...state }
    case constants.EDIT_AIA_NOTE.SUCCESS:
      return {
        ...state
      }
    case constants.DELETE_AIA_NOTE.ACTION:
      return { ...state }
    case constants.DELETE_AIA_NOTE.SUCCESS:
      return {
        ...state
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobAiaActions.js